import React from "react";
import { getCvssSeverity, isMaliciousOrSuspicious } from "../../../utils";
import { CveButtonIcon } from "../index";
import RenderChildrenWrapper from "../RenderChildrenWrapper";
import ClassificationLabel from "./ClassificationLabel";
import styles from "./priorityAndIssues.module.scss";
import SecurityGrade from "./SecurityGrade";
function PriorityAndIssues({ htmlId, componentId = null, path = null, grade = null, severity = null, issueCount = 0, cveStatistics = null, cveTooltipData, classification = "Unknown", badgeWrapper, }) {
    let issuesBadge = (React.createElement(SecurityGrade, { grade: grade, issueCount: issueCount, severity: severity, componentId: componentId, componentPath: path, badgeWrapper: (children) => badgeWrapper("issues", children) }));
    if (isMaliciousOrSuspicious(classification)) {
        issuesBadge = (React.createElement(ClassificationLabel, { id: `classification-label-${htmlId}`, classification: classification, componentId: componentId, componentPath: path, badgeWrapper: (children) => badgeWrapper("classification", children) }));
    }
    return (React.createElement("div", { className: styles.root },
        issuesBadge,
        cveStatistics && (React.createElement(RenderChildrenWrapper, { wrapper: (children) => badgeWrapper("cve", children) },
            React.createElement(CveButtonIcon, { severity: getCvssSeverity(cveStatistics.max_score), tooltipData: cveTooltipData !== null && cveTooltipData !== void 0 ? cveTooltipData : {
                    mostSevere: { score: cveStatistics.max_score },
                }, viewAllLink: (label) => badgeWrapper("cve-view-all", label) })))));
}
export default PriorityAndIssues;
//# sourceMappingURL=PriorityAndIssues.js.map